
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dailyquizzes",
      function () {
        return require("private-next-pages/dailyquizzes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dailyquizzes"])
      });
    }
  